/**
 * Register global components
 */
import Vue from 'vue';

Vue.component('WizardNavigation', require('./components/WizardNavigation.vue').default);
Vue.component('Counter', require('./components/Counter.vue').default);
Vue.component('ButtonGroup', require('./components/ButtonGroup.vue').default);
Vue.component('ErrorMessage', require('./components/ErrorMessage.vue').default);
Vue.component('Quote', require('./components/Quote.vue').default);
Vue.component('Question', require('./components/Question.vue').default);
Vue.component('Insurers', require('./components/Insurers.vue').default);
Vue.component('InfoPopupEndorsements', require('./components/common/InfoPopupEndorsements.vue').default);

